import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Link } from '@grnhse/seedling/lib/birch/typography';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { IconButtonExternalLink } from '@grnhse/seedling/lib/birch/components/buttons';
import PreviewIcon from '@grnhse/seedling/lib/birch/icons/preview';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  Person,
  TalentMatchingApplication,
  RediscoveryApplication,
} from 'talent_matching/types';
import { useRediscoveryRowActionsModal } from 'talent_matching/contexts/rediscovery_row_actions_modal_context';
import { Row as RowComponent } from 'shared/components/birch/row';
import CandidateChips from 'talent_matching/components/shared/candidate_chips';
import { CandidateName } from './base_side_panel';
import { HeaderLink } from './shared';
import {
  ExpandableMenu,
  EllipsisMenuButton,
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';

const t = withLocalePrefix('talent_matching.rediscovery.table.actions');

type Props = {
  application: TalentMatchingApplication;
};

const RediscoverySidePanelHeader = ({ application }: Props) => {
  const { openTagsFor, openProspectFor, openEmailFor } =
    useRediscoveryRowActionsModal();

  const profileUrl = `/people/${application.personId}/applications/${application.id}`;
  const rediscoveryApp = application as unknown as RediscoveryApplication;

  return (
    <Stack spacing={1} sx={{ width: '100%' }}>
      <RowComponent spacing={1} alignItems={'center'}>
        <HeaderLink>
          <Link href={profileUrl} target="_blank">
            <CandidateName large>
              <span className="pii-blur">{application.fullName}</span>
            </CandidateName>
          </Link>
        </HeaderLink>
      </RowComponent>
      <Stack spacing={2}>
        <CandidateChips application={application as Person} showTags />
        <RowComponent spacing={1}>
          <PrimaryButton
            onClick={() => openProspectFor(rediscoveryApp)}
            size="md"
          >
            {t('add_prospect')}
          </PrimaryButton>
          <SecondaryButton
            onClick={() => openTagsFor(rediscoveryApp)}
            size="md"
          >
            {t('tag')}
          </SecondaryButton>
          <IconButtonExternalLink
            icon={PreviewIcon}
            label={t('view_candidate')}
            href={profileUrl}
          />
          <ExpandableMenu>
            <EllipsisMenuButton aria-label={'quick actions'} />
            <MenuList>
              <MenuItem onSelect={() => openEmailFor(rediscoveryApp)}>
                {t('send_email')}
              </MenuItem>
            </MenuList>
          </ExpandableMenu>
        </RowComponent>
      </Stack>
    </Stack>
  );
};

export default RediscoverySidePanelHeader;
